import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { ButtonDropdown, FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemEquipment } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, downloadFile, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

interface DocItem {
  id: string;
  date: string;
  doc: string;
  url: string;
  type: string;
}

export const CMAEquipmentsDocumentsPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [file, setFile] = React.useState<File[]>([]);

  useGlobalState();
  const { navigate } = useRouter();
  const { menu, parameters } = useGlobalState();



  const [equipment, setEquipment] = useState<ItemEquipment>();
  const [type, setType] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [docs, setDocs] = useState<DocItem[]>([]);
  const [doc, setDoc] = useState<DocItem | null>(null);
  const handleDeleteDoc = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/docs.delete',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          idEquipment: parameters.idEquipment,
          type: type,
          fileExtension: doc?.url.split('.').pop()
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();

      addNotificationStatus(data, setData);
      if (data && data.equipment) {
        setEquipment(data.equipment)
        setDocs(data.equipment.docs || [])
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };
  const handleGetEquipment = async () => {
    try {
      if (!parameters.idEquipment || parameters.idEquipment == 0) return;
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/get',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          idEquipment: parameters.idEquipment,
          docs: true
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.equipment) {
        setEquipment(data.equipment)
        setDocs(data.equipment.docs || [])
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleGetEquipment()

  }, [parameters.idEquipment]);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    // 2. Use Optional Chaining (?.) to handle the initial 'null' state safely
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {

      const reader = new FileReader();

      reader.onload = async (e) => {
        // 1. Get the result (data:URL) and strip the prefix
        const result = e.target?.result as string;
        const base64File = result.split(",")[1];

        // 2. Build your payload
        const payload = {
          idEquipment: equipment?.idEquipment,
          fileExtension: file.name.split('.').pop(),
          type: type,
          fileData: base64File
        };
        try {
          setLoading(true);
          const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/private/global/equipments/docs.update',
              'JWT': getCookie("JWT"),
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            throw new Error(`Upload failed: ${response.statusText}`);
          }

          const result = await response.json();
          if (result.code === 0) {
            addNotification(result.status, "success", setData);
            if (result.equipment) {
              setEquipment(result.equipment)
              setDocs(result.equipment.docs || [])
            }
          } else {
            addNotification(result.status, "error", setData);
          }
        } catch (error: any) {
          addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
          setLoading(false);
        }
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    }
  };
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Documentación aeronaves</Header>
          <div style={{ width: 200 }}>
            <FormField label="Seleccione aeronave">
              <SelectEquipment isMant={1} onConfirm={(e) => {
                if (e) setParameters({ ...parameters, idEquipment: e.idEquipment });
                else setParameters({ ...parameters, idEquipment: 0 });
              }} value={parameters?.idEquipment || 0} />
            </FormField>
          </div>
          {parameters && parameters.idEquipment > 0 && (
            <>
              <Table

                variant='embedded'
                columnDefinitions={[
                  {
                    id: "type",
                    header: "Tipo",
                    cell: item => item.type,
                    maxWidth: 100
                  },
                  {
                    id: "doc",
                    header: "Documento",
                    cell: item => item.doc
                  },
                  {
                    id: "date",
                    header: "Fecha",
                    cell: item => item.date == "" ? "N/D" : item.date
                  },
                  {
                    id: "options",
                    header: "",
                    cell: item => (
                      <ButtonDropdown
                        expandToViewport
                        items={[
                          { id: "download", text: "Descargar", disabled: item.url == "" },
                          { id: "upload", text: "Subir" },
                          { id: "delete", text: "Eliminar", disabled: item.url == "" },

                        ]}
                        ariaLabel="Control instance"
                        variant="inline-icon"
                        onItemClick={async (event) => {
                          if (event.detail.id === "upload") {
                            setType(item.type);
                            handleButtonClick();
                          } else if (event.detail.id === "download") {
                            try {
                              setLoading(true);
                              // 2. Use await to wait for the blob to be processed
                              await downloadFile(item.url, item.doc);
                            } catch (error) {
                              console.error("Download failed", error);
                            } finally {
                              // 3. This runs only AFTER downloadFile completes
                              setLoading(false);
                            }
                          } else if (event.detail.id === "delete") {
                            setDoc(item);
                            setType(item.type); setDeleteModalOpen(true);
                          }
                        }}
                      />
                    )
                  },
                ]}

                items={docs}
              />
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }} // Keep it hidden
                accept="image/*,.pdf" // Optional: restrict file types
              />

            </>
          )}
          <ConfirmDelete
            show={deleteModalOpen}
            onDismiss={() => setDeleteModalOpen(false)}
            onConfirm={() => {
              handleDeleteDoc()
            }}
            confirmWord='eliminar documento'
            action='Eliminar'
            warning='Esta acción no es reverseible. El documento se eliminará permanentemente'
            header="Eliminar documento"
            subtitle={<span>¿Está seguro que desea eliminar el documento <strong>{doc?.doc}</strong>?</span>}
          />
        </SpaceBetween>
      }
    />
  );
};
